<div *ngIf="show" [class.bg-green-100]="!isError" [class.bg-red-100]="isError"
    class="fixed top-4 right-4 p-4 rounded-lg shadow-lg max-w-lg transition-opacity duration-300 z-50 border-l-4"
    [class.border-green-500]="!isError" [class.border-red-500]="isError">

    <div class="flex items-start">
        <!-- Ícone de sucesso ou erro -->
        <div class="flex-shrink-0 mt-0.5">
            <svg *ngIf="!isError" class="h-5 w-5 text-green-500" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clip-rule="evenodd" />
            </svg>
            <svg *ngIf="isError" class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clip-rule="evenodd" />
            </svg>
        </div>

        <!-- Mensagem -->
        <div class="ml-3 flex-grow">
            <p [class.text-green-800]="!isError" [class.text-red-800]="isError" class="text-sm font-medium break-words">
                {{ message }}
            </p>
        </div>

        <!-- Botão de fechar -->
        <div class="ml-auto pl-3 flex-shrink-0">
            <button type="button" (click)="onClose()" class="inline-flex rounded-md p-1.5"
                [class.text-green-500]="!isError" [class.text-red-500]="isError"
                [class.hover:text-green-700]="!isError" [class.hover:text-red-700]="isError">
                <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
    </div>
</div>